/*
 * 中央ディスプレイは表示領域と同じ高さに固定し、スクロールを構造的に禁じる。
 *
 * 卓から離れて目視する画面なので、スクロール位置によって見える内容が変わると使えない。
 * 「はみ出さないように気を付ける」ではなく、はみ出せない入れ物にする。
 *
 * 卓が伸びる余地を持つのは中央（.main）だけ。ヘッダ・運営操作・勝者選択は必要な高さを
 * 取り、残りを卓が使う。これにより勝者選択のシートが出ても運営操作が押し出されて隠れない。
 */

.shell {
  height: 100vh;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/*
 * 卓と、参加パネル・履歴の配置。flex アイテムは既定で縮まないため min-height を 0 にする。
 * これが無いと中身の高さのぶんだけ shell を突き破る。
 *
 * 横向きは「卓 | 参加 + 履歴」。卓は高さに合わせて幅を決める。
 */
.main {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: grid;
  gap: var(--mantine-spacing-md);
  grid-template-columns: minmax(0, 2fr) minmax(16rem, 1fr);
  /*
   * 参加パネルの直下に履歴を置き、余りは最下段に回す。履歴の段は 30vh を上限に、
   * 画面が低いときは縮む（中でスクロールする）。
   */
  grid-template-rows: auto minmax(0, 30vh) minmax(0, 1fr);
  grid-template-areas:
    'table join'
    'table log'
    'table .';
}

.table {
  grid-area: table;
  min-height: 0;
  min-width: 0;
}

.join {
  grid-area: join;
  min-width: 0;
}

/* 高さは段が決める。外側が中身に合わせて伸びると、ページがスクロールを要する。 */
.log {
  grid-area: log;
  min-height: 0;
}

/* 横向きで参加パネルが無いとき（満席）は、履歴を上へ詰める。 */
.main:not(:has(.join)) {
  grid-template-rows: minmax(0, 30vh) minmax(0, 1fr);
  grid-template-areas:
    'table log'
    'table .';
}

/*
 * 縦向き（タブレットを縦に置いた場合）は「卓（全幅）/ 参加 | 履歴」。横に並べると卓が
 * 画面幅の 2/3 に縮み、下半分が空いたまま履歴が画面外に押し出される。
 *
 * 卓は幅いっぱいに取り、高さは縦横比から決まる。残りの高さを参加パネルと履歴で分ける。
 */
@media (orientation: portrait) {
  .main {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    grid-template-rows: auto minmax(0, 1fr);
    grid-template-areas:
      'table table'
      'join log';
  }

  .main:not(:has(.join)) {
    grid-template-rows: auto minmax(0, 1fr);
    grid-template-areas:
      'table table'
      'log log';
  }
}
